<template>
  <div class="single-ticket-user">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>单票用户</span>
      </div>
      
      <!-- 搜索工具栏 -->
      <div class="search-toolbar">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="自定义检索">
            <el-select v-model="searchType" placeholder="请选择" @change="handleSearchTypeChange">
              <el-option label="按公司名称" value="1"></el-option>
              <el-option label="按手机号码" value="2"></el-option>
              <el-option label="按注册时间" value="4"></el-option>
              <el-option label="按产品名称" value="6"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item v-if="searchType === '1'">
            <el-input v-model="searchForm.companyName" placeholder="公司名称" clearable></el-input>
          </el-form-item>
          
          <el-form-item v-if="searchType === '2'">
            <el-input v-model="searchForm.mobile" placeholder="手机号码" clearable></el-input>
          </el-form-item>
          
          <el-form-item v-if="searchType === '4'">
            <el-date-picker
              v-model="searchForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp">
            </el-date-picker>
          </el-form-item>
          
          <el-form-item v-if="searchType === '6'">
            <el-select v-model="searchForm.productId" placeholder="请选择产品">
              <el-option
                v-for="item in productList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">全部</el-button>
            <el-button type="primary" @click="handleCreateUser">创建单票用户</el-button>
            <el-button type="success" @click="handleExportExcel">导出Excel</el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <!-- 数据表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        v-loading="loading"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="company_name" label="公司名称" width="280" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.company_id > 0" class="company-link" @click="viewCompanyDetail(scope.row.company_id)">
              {{ scope.row.company_name }}
            </span>
            <span v-else>{{ scope.row.company_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" width="160" align="center"></el-table-column>
        <el-table-column prop="app_name" label="平台名称" width="150" align="center"></el-table-column>
        <el-table-column prop="product_name" label="产品名称" width="250" align="center"></el-table-column>
        <el-table-column prop="price_name" label="方案名称" width="250" align="center"></el-table-column>
        <el-table-column prop="channel_name" label="渠道归属" width="160" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.channel_name">
              {{ scope.row.channel_name }}({{ scope.row.alias }})
            </span>
            <span v-else>{{ scope.row.alias }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deposit" label="总充值金额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="expense" label="消费金额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="balance" label="账户余额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="agreement_url" label="协议文件" width="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.agreement_url" class="link" @click="viewUrl(scope.row.agreement_url)">查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="policy_url" label="电子保单" width="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.policy_url" class="link" @click="viewUrl(scope.row.policy_url)">查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="effected_at" label="生效时间" width="160" :formatter="dateFormat" align="center"></el-table-column>
        <el-table-column prop="expired_at" label="失效时间" width="160" :formatter="dateFormat" align="center"></el-table-column>
        <el-table-column prop="created_at" label="注册时间" width="160" :formatter="dateFormat" align="center"></el-table-column>
        <el-table-column prop="disabled" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.disabled ? 'danger' : 'success'">
              {{ scope.row.disabled ? '锁定' : '正常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="320" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.disabled"
              size="mini"
              type="success"
              @click="handleUpdateStatus(scope.row.id, false, 'status')">
              解锁
            </el-button>
            <template v-else>
              <el-button size="mini" type="warning" @click="handleUpdateStatus(scope.row.id, true, 'status')">锁定</el-button>
              <el-button v-if="scope.row.company_id > 0" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button 
                v-if="(scope.row.pay_type==16 || scope.row.pay_type==1) && scope.row.is_allow_deposit_online" 
                size="mini" 
                @click="handleDeposit(scope.row.id)">
                充值
              </el-button>
              <el-button 
                v-else-if="scope.row.is_allow_deposit_offline" 
                size="mini" 
                @click="handleDeposit(scope.row.id)">
                充值
              </el-button>
              <el-button 
                v-if="scope.row.is_upload_agreement" 
                size="mini" 
                @click="handleAgreement(scope.row.id, 'xy')">
                上传协议
              </el-button>
              <el-button 
                v-if="scope.row.is_upload_policy_file" 
                size="mini" 
                @click="handleAgreement(scope.row.id, 'bd')">
                上传保单
              </el-button>
              <el-button size="mini" @click="handleChangeChannel(scope.row.id, scope.row.app_id)">变更渠道</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 15, 20]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px;">
      </el-pagination>
    </el-card>
    
    <!-- 创建单票用户弹窗 -->
    <CreateSingleUser 
      :visible.sync="showCreateDialog" 
      @success="handleCreateSuccess" 
      @close="handleCreateClose" 
    />
    
    <!-- 编辑用户弹窗 -->
    <EditSingleUser 
      :visible.sync="showEditDialog" 
      :company-info="currentCompanyInfo"
      @success="handleEditSuccess" 
      @close="handleEditClose" 
    />
    
    <!-- 充值弹窗 -->
    <Deposit 
      :visible.sync="showDepositDialog" 
      :user-id="currentUserId"
      @success="handleDepositSuccess" 
      @close="handleDepositClose" 
    />
    
    <!-- 变更渠道弹窗 -->
    <ChangeChannel 
      :visible.sync="showChangeChannelDialog" 
      :user-id="currentUserId"
      :app-id="currentAppId"
      @success="handleChangeChannelSuccess" 
      @close="handleChangeChannelClose" 
    />
    
    <!-- 录入协议/保单弹窗 -->
    <Agreement 
      :visible.sync="showAgreementDialog" 
      :user-id="currentUserId"
      :type="agreementType"
      @success="handleAgreementSuccess" 
      @close="handleAgreementClose" 
    />
  </div>
</template>

<script>
import { formatDate, formatMoney } from '@/utils/formatter'
import { 
  singleUserList, 
  getProductList,
  createSingleUser,
  getSingleUserInfo,
  updateSingleUser,
  disabledSingleUser,
  manualSingleUserDeposit,
  saveSingleUserPolicy,
  changeSingleUserChannel
} from '@/api/member'
import CreateSingleUser from './singleComponents/CreateSingleUser.vue'
import EditSingleUser from './singleComponents/EditSingleUser.vue'
import Deposit from './singleComponents/Deposit.vue'
import ChangeChannel from './singleComponents/ChangeChannel.vue'
import Agreement from './singleComponents/Agreement.vue'

export default {
  name: 'SingleTicketUser',
  components: {
    CreateSingleUser,
    EditSingleUser,
    Deposit,
    ChangeChannel,
    Agreement
  },
  data() {
    return {
      loading: false,
      searchType: '1',
      searchForm: {
        companyName: '',
        mobile: '',
        dateRange: [],
        productId: ''
      },
      tableData: [],
      multipleSelection: [],
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      },
      productList: [],
      // 弹窗相关
      showCreateDialog: false,
      showEditDialog: false,
      showDepositDialog: false,
      showChangeChannelDialog: false,
      showAgreementDialog: false,
      currentUserId: '',
      currentAppId: '',
      currentCompanyInfo: {},
      agreementType: 'xy'
    }
  },
  created() {
    this.fetchData()
    this.fetchProductList()
  },
  methods: {
    // 获取数据
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          rows: this.pagination.pageSize,
          platform_type: 8,
          ...this.buildSearchParams()
        }
        
        const res = await singleUserList(params)
        this.tableData = res.rows || []
        this.pagination.total = res.total || 0
      } catch (error) {
        console.error('获取单票用户列表失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    
    // 构建搜索参数
    buildSearchParams() {
      const params = {}
      
      switch (this.searchType) {
        case '1':
          if (this.searchForm.companyName) {
            params.company_name = this.searchForm.companyName
          }
          break
        case '2':
          if (this.searchForm.mobile) {
            params.mobile = this.searchForm.mobile
          }
          break
        case '4':
          if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
            params.begin_date = Math.floor(this.searchForm.dateRange[0] / 1000)
            params.end_date = Math.floor(this.searchForm.dateRange[1] / 1000)
          }
          break
        case '6':
          if (this.searchForm.productId) {
            params.product_id = this.searchForm.productId
          }
          break
      }
      
      return params
    },
    
    // 获取产品列表
    async fetchProductList() {
      try {
        const res = await getProductList()
        this.productList = res.rows || []
      } catch (error) {
        console.error('获取产品列表失败:', error)
      }
    },
    
    // 搜索类型变化
    handleSearchTypeChange() {
      // 重置搜索表单
      this.searchForm.companyName = ''
      this.searchForm.mobile = ''
      this.searchForm.dateRange = []
      this.searchForm.productId = ''
    },
    
    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchData()
    },
    
    // 重置
    handleReset() {
      this.searchForm = {
        companyName: '',
        mobile: '',
        dateRange: [],
        productId: ''
      }
      this.searchType = '1'
      this.pagination.currentPage = 1
      this.fetchData()
    },
    
    // 创建用户
    handleCreateUser() {
      this.showCreateDialog = true
    },
    
    // 创建用户成功回调
    handleCreateSuccess() {
      this.fetchData()
    },
    
    // 创建用户关闭回调
    handleCreateClose() {
      this.showCreateDialog = false
    },
    
    // 导出Excel
    async handleExportExcel() {
      try {
        // 构建搜索参数
        const params = {
          platform_type: 8,
          ...this.buildSearchParams()
        }
        
        const res = await singleUserList(params)
        if (res.err_code === 0) {
          // 这里应该调用实际的导出Excel功能
          // 暂时用提示代替
          this.$message.success('导出Excel功能已触发')
          
          // 示例导出逻辑（需要根据实际需求调整）
          /*
          const data = res.rows || []
          const exportData = data.map(item => ({
            '公司': item.company_name,
            '手机号': item.mobile,
            '平台名称': item.app_name,
            '渠道商': item.channel_name ? `${item.channel_name}(${item.alias})` : item.alias,
            '总充值金额(元)': this.formatMoneyForExport(item.deposit),
            '消费金额(元)': this.formatMoneyForExport(item.expense),
            '账户余额(元)': this.formatMoneyForExport(item.balance),
            '生效时间': this.formatDateForExport(item.effected_at),
            '失效时间': this.formatDateForExport(item.expired_at),
            '注册时间': this.formatDateForExport(item.created_at)
          }))
          
          // 调用导出函数
          this.exportToExcel(exportData, '单票用户')
          */
        } else {
          this.$message.error('导出失败')
        }
      } catch (error) {
        console.error('导出Excel失败:', error)
        this.$message.error('导出失败')
      }
    },
    
    // 查看公司详情
    viewCompanyDetail(companyId) {
      this.$message.info(`查看公司详情，ID: ${companyId}`)
    },
    
    // 编辑
    handleEdit(row) {
      this.currentCompanyInfo = row
      this.showEditDialog = true
    },
    
    // 编辑成功回调
    handleEditSuccess() {
      this.fetchData()
    },
    
    // 编辑关闭回调
    handleEditClose() {
      this.showEditDialog = false
    },
    
    // 查看URL
    viewUrl(url) {
      window.open(url, '_blank')
    },
    
    // 变更渠道
    handleChangeChannel(userId, appId) {
      this.currentUserId = userId
      this.currentAppId = appId
      this.showChangeChannelDialog = true
    },
    
    // 变更渠道成功回调
    handleChangeChannelSuccess() {
      this.fetchData()
    },
    
    // 变更渠道关闭回调
    handleChangeChannelClose() {
      this.showChangeChannelDialog = false
    },
    
    // 充值
    handleDeposit(userId) {
      this.currentUserId = userId
      this.showDepositDialog = true
    },
    
    // 充值成功回调
    handleDepositSuccess() {
      this.fetchData()
    },
    
    // 充值关闭回调
    handleDepositClose() {
      this.showDepositDialog = false
    },
    
    // 上传协议/保单
    handleAgreement(userId, type) {
      this.currentUserId = userId
      this.agreementType = type
      this.showAgreementDialog = true
    },
    
    // 录入协议/保单成功回调
    handleAgreementSuccess() {
      this.fetchData()
    },
    
    // 录入协议/保单关闭回调
    handleAgreementClose() {
      this.showAgreementDialog = false
    },
    
    // 更新状态
    async handleUpdateStatus(userId, status, action) {
      this.$confirm(`您确认想要修改用户的状态为"${status ? '锁定' : '启用'}"吗？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const params = {
            user_id: userId,
            disabled: status
          }
          const res = await disabledSingleUser(params)
          if (res.err_code === 0) {
            this.$message.success('修改成功')
            this.fetchData()
          } else {
            this.$message.error(res.err_msg || '修改失败')
          }
        } catch (error) {
          console.error('更新状态失败:', error)
          this.$message.error('修改失败')
        }
      }).catch(() => {
        // 取消操作
      })
    },
    
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    
    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchData()
    },
    
    // 当前页变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchData()
    },
    
    // 金额格式化
    moneyFormat(row, column, cellValue) {
      return formatMoney(cellValue)
    },
    
    // 日期格式化
    dateFormat(row, column, cellValue) {
      // 检查是否为有效时间值
      // 不显示不正常的时间（如默认值、空值等）
      if (!cellValue || 
          cellValue === '0001-01-01T00:00:00Z' || 
          cellValue === '1970-01-01T00:00:00Z' ||
          cellValue === '0000-00-00 00:00:00' ||
          cellValue === '0000-00-00T00:00:00Z') {
        return ''
      }
      
      // 检查是否为有效的时间戳
      const timestamp = Date.parse(cellValue);
      if (isNaN(timestamp)) {
        return ''
      }
      
      return formatDate(cellValue)
    },
    
    // 用于导出的金额格式化
    formatMoneyForExport(value) {
      if (!value && value !== 0) return ''
      return (value / 100).toFixed(2)
    },
    
    // 用于导出的日期格式化
    formatDateForExport(date) {
      if (!date || 
          date === '0001-01-01T00:00:00Z' || 
          date === '1970-01-01T00:00:00Z' ||
          date === '0000-00-00 00:00:00' ||
          date === '0000-00-00T00:00:00Z') {
        return ''
      }
      
      const timestamp = Date.parse(date)
      if (isNaN(timestamp)) {
        return ''
      }
      
      return formatDate(date, 'YYYY-MM-DD')
    },
    
    // 导出到Excel（示例方法）
    exportToExcel(data, fileName) {
      // 这里应该实现实际的Excel导出逻辑
      // 可以使用xlsx等库来实现
      console.log('导出数据:', data)
      this.$message.success(`"${fileName}"导出成功`)
    }
  }
}
</script>

<style lang="less" scoped>
.single-ticket-user {
  padding: 20px;
  
  .search-toolbar {
    margin-bottom: 20px;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
  
  .company-link, .link {
    color: #409EFF;
    cursor: pointer;
    
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>